import React, { Fragment } from 'react';
import { BoxIcon, PaintBucketIcon, RefrigeratorIcon, SofaIcon, SquareIcon } from 'lucide-react';
interface SidebarCategoriesProps {
  categories: any[];
  activeCategory: string;
  handleCategorySelect: (categoryId: string) => void;
  categoriesCollapsed: boolean;
}
export function SidebarCategories({
  categories,
  activeCategory,
  handleCategorySelect,
  categoriesCollapsed
}: SidebarCategoriesProps) {
  if (categoriesCollapsed) return null;
  return <div className="w-24 border-r border-gray-200 dark:border-darkbg-border overflow-y-auto" data-id="element-899">
      <div className="p-2" data-id="element-900">
        <div className="mb-2" data-id="element-901">
          {categories.map(category => <Fragment key={category.id} data-id="element-902">
              {category.hasDivider && <div className="border-t border-gray-200 dark:border-darkbg-border my-4" data-id="element-903"></div>}
              <button onClick={() => handleCategorySelect(category.id)} className={`w-full flex flex-col items-center p-2 rounded-md mb-2 ${activeCategory === category.id ? 'bg-blue-100 text-blue-700 dark:bg-blue-900/20 dark:text-accent-blue' : 'text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-darkbg-primary'}`} title={category.name} data-id="element-904">
                {category.id === 'carpentry' && <BoxIcon className="h-5 w-5 mb-1" data-id="element-905" />}
                {category.id === 'appliances' && <RefrigeratorIcon className="h-5 w-5 mb-1" data-id="element-906" />}
                {category.id === 'styling' && <SofaIcon className="h-5 w-5 mb-1" data-id="element-907" />}
                {category.id === 'materials' && <PaintBucketIcon className="h-5 w-5 mb-1" data-id="element-908" />}
                {category.id === 'fronts' && <SquareIcon className="h-5 w-5 mb-1" data-id="element-909" />}
                <span className="text-xs" data-id="element-910">{category.name}</span>
              </button>
            </Fragment>)}
        </div>
      </div>
    </div>;
}